import { WohaCommonContent } from "../../../../modules/content/components/WohaCommonContent/WohaCommonContent";
import { WohaSection } from "../../../../modules/content/components/WohaSection/WohaSection";
import type { ISimpleHeroBlockProps } from "./SimpleHeroBlock.props";
export const SimpleHeroBlock = ({
  alignment,
  anchorId,
  buttons,
  description,
  eyebrow,
  heading,
  parentClass,
  spacing,
}: ISimpleHeroBlockProps) => {
  if (!eyebrow && !heading && !description && !buttons?.length) return null;
  return (
    <WohaSection className={parentClass} id={anchorId} spacing={spacing}>
      <div className="woha-background-dots overflow-hidden rounded-2xl border border-ash p-7 md:p-12 lg:p-16">
        <WohaCommonContent
          alignment={alignment}
          buttons={buttons}
          className="py-4 md:py-8"
          description={description}
          eyebrow={eyebrow}
          heading={heading}
          headingAs="h1"
          headingClassName="max-w-[16ch] text-5xl md:text-6xl lg:text-[4.5rem]"
        />
      </div>
    </WohaSection>
  );
};
SimpleHeroBlock.displayName = "Block::SimpleHeroBlock";
